<template>
      <b-container>
          <b-row>
                <b-col md="6">
                    <b-overlay :show="isLoadingUserForm" rounded="sm" >
                        <b-card header="Details" class="my-1">
                            <b-form @submit="onSubmitUserForm">
                                <b-form-group
                                    label="Name:"
                                    label-for="input-name">
                                    <b-form-input
                                        id="input-name"
                                        v-model="userForm.name"
                                        type="text"
                                        placeholder="Enter name" />
                                </b-form-group>

                                <b-form-group 
                                    label="Phone:"
                                    label-for="input-phone">
                                    <b-form-input
                                        id="input-phone"
                                        type="tel"
                                        v-model="userForm.phone"
                                        placeholder="Enter phone" />
                                </b-form-group>
                                <div class="text-right">
                                    <b-button type="submit" variant="primary" right>Update</b-button>
                                </div>
                            </b-form>
                        </b-card>
                    </b-overlay>
                </b-col>

                <b-col md="6">
                    <b-overlay :show="isLoadingPasswordForm" rounded="sm" >
                        <b-card header="Security" class="my-1">
                            <b-form @submit="onSubmitPasswordForm">
                                <b-form-group
                                    label="Password:"
                                    label-for="input-password">
                                    <b-form-input
                                        id="input-password"
                                        v-model="passwordForm.oldPassword"
                                        type="password"
                                        placeholder="Enter Password"
                                        autocomplete="off"
                                        @keydown.space.prevent
                                        required/>
                                </b-form-group>

                                <b-form-group
                                    label="New Password:"
                                    label-for="input-password-new">
                                    <b-form-input
                                        id="input-password-new"
                                        v-model="passwordForm.newPassword"
                                        type="password"
                                        placeholder="Enter New Password"
                                        autocomplete="off"
                                        @keydown.space.prevent
                                        required/>
                                </b-form-group>

                                <b-form-group
                                    label="Confirm Password:"
                                    label-for="input-password-confirm" >
                                    <b-form-input
                                        id="input-password-confirm"
                                        v-model="passwordForm.confirmPassword"
                                        type="password"
                                        placeholder="Enter New Password"
                                        autocomplete="off"
                                        @keydown.space.prevent
                                        required/>
                                </b-form-group>

                                <div class="text-right">
                                    <b-button type="submit" variant="primary" right>Update</b-button>
                                </div>
                            </b-form>
                        </b-card>
                    </b-overlay>
                </b-col>
                <b-col md="6">
                    <setting-notification/>
                </b-col>
          </b-row>
      </b-container>
</template>

<script>
import { mapState } from 'vuex'
import Swal from 'sweetalert2'
import SettingNotification from "@/components/portal/SettingNotification"

export default {
    computed: {
		...mapState({
            userInfo:"userInfo"
		})
    },
    components:{ "SettingNotification" : SettingNotification },
    data() {
        return { 
            userForm:{},
            passwordForm:{},
            isLoadingUserForm:false,
            isLoadingPasswordForm:false,
        }
    },
    mounted() {
        this.userForm = this.$deepCopy(this.userInfo)
    },
    methods: {
        onSubmitUserForm(event) {
            event.preventDefault()
            let {_id, name, phone} = this.userForm;
            let reqForm = { _id : _id }
            if(name) reqForm.name = name;
            if(phone) reqForm.phone = phone;
            this.isLoadingUserForm = true;
            this.$store.dispatch('apiEditUser', reqForm)
                       .then(({status, error}) => {
                           this.isLoadingUserForm = false;
                           if(status) {
                                this.$store.commit('updateUserInfo', this.userForm)
                                Swal.fire('Updated', 'Successfully Updated', 'success')
                           } else {
                               console.error("error",error)
                               Swal.fire('Error',error.msg,'error')
                           }
                       })
                       .catch(({error, msgError})=>{
                           this.isLoadingUserForm = false;
                           console.error("apiProfileUserUpdate-E", error)  
                           Swal.fire('Error',msgError,'error')   
                       })
        },
        onSubmitPasswordForm(event) {
            event.preventDefault()
            let {newPassword, confirmPassword} = this.passwordForm
            let warning = newPassword !== confirmPassword ? "New Password and Confirm Password does not match" : null;
            if(warning){
               Swal.fire('Warning', warning, 'warning') 
               return
            }

            this.isLoadingPasswordForm = true;
            this.$store.dispatch('apiSetUserPassword', this.passwordForm)
                       .then(({status, error}) => {
                           this.isLoadingPasswordForm = false;
                           if(status) {
                               this.passwordForm = {}
                                Swal.fire('Updated', 'Successfully Updated', 'success')
                           } else {
                               console.error("error",error)
                               Swal.fire('Error',error.msg,'error')
                           }
                       })
                       .catch(({error, msgError})=>{
                           this.isLoadingPasswordForm = false;
                           console.error("apiSetUserPassword-E", error)  
                           Swal.fire('Error',msgError,'error')   
                       })
        }
    }
}
</script>

<style>

</style>